import Autocomplete from '@mui/material/Autocomplete';
import { LegacyInput } from '../internal/LegacyInput';
import type { TableColumn } from '../tanstackTypes';
import type { ColumnFilterProps } from '../types';
import { useTableTexts } from '../useTableTexts';
import { AutocompletePopperComponent } from './AutocompletePopperComponent';
import { getFilterInputProps } from './util';

type CompareValues = (a: unknown, b: unknown) => number;

interface Props extends ColumnFilterProps {
  compareValues: CompareValues;
}

function getOptions(column: TableColumn<any>, compareValues: CompareValues) {
  return Array.from(column.getFacetedUniqueValues(), ([value, count]) => ({
    value,
    count,
  }))
    .filter(({ value }) => value !== undefined)
    .sort((a, b) => compareValues(a.value, b.value));
}

export const BaseSelectColumnFilter = ({
  column,
  translateValue = (value) => value,
  layout,
  compareValues,
}: Props) => {
  const texts = useTableTexts();
  const options = getOptions(column, compareValues);
  const value =
    options.find(({ value }) => value === column.getFilterValue()) ?? null;

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(_, option) => column.setFilterValue(option?.value)}
      getOptionLabel={(option) =>
        `${translateValue(option.value)} (${option.count})`
      }
      renderInput={(params) => (
        <LegacyInput
          {...params}
          placeholder="Filter..."
          {...getFilterInputProps(column, layout, texts)}
        />
      )}
      slots={{ popper: AutocompletePopperComponent }}
      sx={{
        ...(layout === 'header' && {
          '& .MuiFilledInput-root': { paddingY: '3px' },
        }),
      }}
    />
  );
};
